import { render, staticRenderFns } from "./OfferCardDescription.vue?vue&type=template&id=f5d04964&"
import script from "./OfferCardDescription.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OfferCardDescription.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OfferCardDescription.vue?vue&type=style&index=0&id=f5d04964&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports